import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import useI18n from './useI18n';

export const useLocaleFormat = () => {
  const { languages, resolvedLanguage } = useI18n();
  const currentLangCode = resolvedLanguage as keyof typeof languages;
  const locale = languages[currentLangCode]?.locale ?? enGB;

  const formatDate = (date: Date | number, formatStr: string = 'P') => {
    return format(date, formatStr, { locale });
  };

  const formatNumber = (input: number | string) => {
    let decimals = 0;
    let isPercentageValue = false;
    const codesRequireSpace = ['de', 'fr'];
    const space = codesRequireSpace.includes(currentLangCode) ? ' ' : '';

    if (typeof input === 'string') {
      isPercentageValue = input.includes('%');
      input = parseFloat(input);
    }

    if (input < 10) {
      decimals = 2;
    } else if (input < 100) {
      decimals = 1;
    }

    return (
      input.toLocaleString(currentLangCode, {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }) + (isPercentageValue ? space + '%' : '')
    );
  };

  return {
    formatNumber,
    formatDate,
    locale,
  };
};
